/**
 * Classe responsável por criar o menu que exibe o minimo. o máximo, a média e a soma da coluna selecionada.
 * @author Adalto Junior
 * DATE: 04/09/2013
 *
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.MenuShowTotals = function (entity, gridContainner, entityToAggregate) {

    var _entity = entity,
        _selector =  "#" + _entity + " .slick-header-menu",
        menuHeader = null;

    if (gridContainner) {

        _selector = gridContainner + " .slick-header-menu";

    }

    var initializeNameSpace = function () {


        App.Forms = App.Forms || {};
        App.Forms[entity] = App.Forms[entity] || {};
        App.Forms[entity].scroll = {lastScrollLeft: 0};

    };


    var appendMenuItem = function (labelMenu, valueItem) {

        var error = null,
            divParent = null,
            divText = null,
            divValue = null;

        try {

            divParent = document.createElement("div");
            divText = document.createElement("span");
            divValue = document.createElement("span");

            divText.setAttribute("class", "menuShowTotalsText");
            divValue.setAttribute("class", "menuShowTotalsValue");

            divText.innerHTML = labelMenu;
            divValue.innerHTML = valueItem;

            divParent.appendChild(divText);
            divParent.appendChild(divValue);

            return divParent;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on append menu item.");
            error.console();

        }

    };

    var updateMenuWithShowGridTotals = function (data, column, positionMenu) {

        var error = null,
            menu = null,
            fragment = null,
            routerOrStopEntity = false,
            windowWidthDiff = 0,
            iconMenuWidth = 15,
            reduceColumn = null;

        try {

            menu = document.querySelector(_selector);

            if (entityToAggregate) {

                entity = entityToAggregate;

            }

            routerOrStopEntity = (entity === "Route" || entity === 'RouteSummaryRoutes' || entity === 'RouteSummaryStops' || 'Stops');

            if (menu) {

                fragment = document.createDocumentFragment();

                menu.innerHTML = '';

                reduceColumn = function(object, name){
                    if(object && name){
                        return object[name];
                    }
                };

                for (var i in data) {

                    var labelMenu = "",
                        columnName = column.field,
                        fieldInformation = column.fieldInformation,
                        valueFormatted = 0,
                        model = null,
                        i18n = Monet.I18n;

                    model = new App.Models[entity]();

                    if (i === "sum") {

                        labelMenu = i18n.getResourcesByKey("Greenmile.grid.showTotals.sum");

                    } else if (i === "min") {

                        labelMenu = i18n.getResourcesByKey("Greenmile.grid.showTotals.min");

                    } else if (i === "max") {

                        labelMenu = i18n.getResourcesByKey("Greenmile.grid.showTotals.max");

                    } else if (i === "avg") {

                        labelMenu = i18n.getResourcesByKey("Greenmile.grid.showTotals.avg");

                    }

                    var dataValue = data[i][columnName];

                    if (!dataValue) {

                        var object = data[i];
                        dataValue = columnName.split(".").reduce(reduceColumn, object);

                    }

                    if (dataValue) {
                        model.set(data[i]);


                        if (fieldInformation.type === "DISTANCE" && routerOrStopEntity) {
                            var distanceFormat = new Monet.Format.DISTANCE(dataValue);
                            dataValue = distanceFormat.toGrid().getValue();

                        }

                        var decimalFormat = new Monet.Format.DECIMAL(dataValue);
                        valueFormatted = decimalFormat.format().getValue();

                    } else if(dataValue !== 0){

                        valueFormatted = i18n.getResourcesByKey("Greenmile.grid.showTotals.nothingData");

                    }

                    fragment.appendChild(appendMenuItem(labelMenu, valueFormatted));

                }

                menu.appendChild(fragment);
                windowWidthDiff = (menu.offsetWidth + positionMenu) - window.outerWidth;

                if (windowWidthDiff > 0) {
                    menu.style.left = (parseInt(menu.style.left, 10) - (menu.offsetWidth - iconMenuWidth)) + 'px';
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on menu update after load");
            error.console();
        }

    };

    var formatBodyToSearch = function (column) {

        var error = null,
            content = null,
            contentString = "",
            filter = {},
            searchOnEntityNotScreen = false;

        try {

            if (typeof column !== "undefined") {

                content = {
                    "aggregate": [
                        {
                            "function": "SUM",
                            "attr": [ column ]
                        },
                        {
                            "function": "MIN",
                            "attr": [ column ]
                        },
                        {
                            "function": "MAX",
                            "attr": [ column ]
                        },
                        {
                            "function": "AVG",
                            "attr": [ column ]
                        }
                    ]
                };

                if (entityToAggregate) {
                    searchOnEntityNotScreen = true;
                }

                if (App.Forms[_entity] && App.Forms[_entity].filterBuilder) {
                    filter = App.Forms[_entity].filterBuilder.getCriteriaChain();
                } else {
                    filter = App.Objects[_entity].getFilter(searchOnEntityNotScreen);
                }

                if (_entity.match(/RouteDetails/)) {
                    filter.criteriaChain[0].and.push({
                        attr: 'route.id',
                        eq: _entity.replace('RouteDetails_', '')
                    });
                } else if (_entity.match(/RouteSummaryOrders/)) {
                    filter.criteriaChain[0].and = filter.criteriaChain[0].and.map(criteria => {
                        return {
                            ...criteria,
                            attr: criteria.attr.replace(/routeView/, "stop")
                        }
                    });
                }

                if (filter.criteriaChain) {

                    content.criteriaChain = filter.criteriaChain;

                }

                contentString = JSON.stringify(content);

            }

            return contentString;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on formt body to search.");
            error.console();

        }

    };

    var requestTotalsAndUpdateMenu = function (column, positionMenu) {

        var error = null,
            ajax = null,
            entity = _entity;

        try {

            ajax = new Monet.Ajax();

            if (entityToAggregate) {

                entity = entityToAggregate;

            }

            ajax.url = entity + "/aggregate";
            ajax.method = 'post';
            ajax.data = formatBodyToSearch(column.field);

            ajax.success = function (totals) {
                if (totals) {
                    updateMenuWithShowGridTotals(totals, column, positionMenu);
                }
            };

            ajax.error = function (xhr) {

                Monet.Configurations.errorNotification(null, xhr, null, null);

            };

            ajax.send();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on request totals and update menu");
            error.console();

        }
    };

    var removePopupMenuHeader = function () {

        var error = null,
            menu = null,
            menuActive = null,
            menuActiveSelector = "",
            className = "";

        try {

            menuActiveSelector = "#" + _entity + " .slick-header-column-active";

            if (gridContainner) {
                menuActiveSelector = gridContainner + " .slick-header-column-active";
            }

            menu = document.querySelector(_selector);
            menuActive = document.querySelector(menuActiveSelector);

            if (menu) {
                menu.parentNode.removeChild(menu);
            }

            if (menuActive) {
                className = menuActive.className;
                menuActive.className = className.replace("slick-header-column-active", "");
            }


        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on remove popup header menu.");
            error.console();
        }

    };

    var bindRemoveMenuOnScrollVertical = function () {

        var error = null,
            viewPortClass = "",
            grid = null,
            div = null,
            selector = null;

        try {

            grid = App.Forms[_entity].table;

            if (grid.getOptions().frozenColumn === -1) {
                viewPortClass = " .slick-viewport-left";
            } else {
                viewPortClass = " .slick-viewport-right";
            }

            selector = "#" + _entity + viewPortClass;

            if (gridContainner) {

                selector = gridContainner + viewPortClass;

            }

            div = document.querySelector(selector);

            if (div) {

                div.addEventListener("scroll", function() {

                    var scroll,
                        scrollIsHorizontal;


                    scroll = App.Forms[ _entity].scroll;
                    scrollIsHorizontal = this.scrollLeft !== scroll.lastScrollLeft;

                    if (scrollIsHorizontal) {
                        removePopupMenuHeader();
                    }

                    scroll.lastScrollLeft = this.scrollLeft;


                }, false);

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on bind remove scroll vertical");
            error.console();
        }
    };

    menuHeader = new Slick.Plugins.HeaderMenu({});

    menuHeader.onBeforeMenuShow.subscribe(function (e, args) {

        requestTotalsAndUpdateMenu(args.column, e.clientX);

    });

    initializeNameSpace();
    bindRemoveMenuOnScrollVertical();


    return menuHeader;

};
